import { initializeApp } from "firebase/app"
import { getFunctions } from 'firebase/functions'

import firebaseConfig from "../config/firebase"

const app = initializeApp(firebaseConfig)
const functions = getFunctions(app)

export default app